<h2 mat-dialog-title>Inserimento {{data.name}}</h2>
<mat-dialog-content>
    <p>Nuovo elemento</p>

    <div class="row">
        <div class="col">

            <mat-form-field>
                <!--<mat-label>Favorite Animal</mat-label>
        <input matInput [(ngModel)]="animal" />-->
                <mat-label for="labeld">Etichetta</mat-label>
                <input matInput id="labeld" [(ngModel)]="labelText" placeholder="Inserisci etichetta" />
            </mat-form-field>

        </div>
    </div>


    <div class="row">
        <div class="col">
            <mat-form-field>
                <mat-label for="elementType2">Tipo di elemento</mat-label>
                <mat-select [(ngModel)]="selectedElementType" id="elementType2">
                    <mat-option value="input">Input</mat-option>
                    <mat-option value="textarea">Textarea</mat-option>
                    <mat-option value="checkbox">Checkbox</mat-option>
                    <mat-option value="select">Select</mat-option>
                    <mat-option value="header">Header</mat-option>
                    <mat-option value="IntestazioneSezione">IntestazioneSezione</mat-option>
                    <mat-option value="section">Section</mat-option>
                    <mat-option value="subSection">Sub-section</mat-option>
                </mat-select>
                <!--<mat-hint align="end">Nessuna selezione</mat-hint>-->
            </mat-form-field>
        </div>
    </div>


</mat-dialog-content>


<mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Chiudi</button>
    <button mat-button (click)="crea()" cdkFocusInitial>Aggiungi</button>
</mat-dialog-actions>


